<template>
  <div>
    <nav_list :index="2"></nav_list>


    <div class="  v3_body">


      <navv :title="$lang('37398')" en="Seat type">
      </navv>

      <div class="gb-tabs">
        <div class="gb-tabs-header">
          <div class="gb-tab" v-bind:class="{agtabat:i==curr}" v-for="(itm, i) in list" :key="i" @click="set_curr(i)">
            {{ itm.strs.title }}
          </div>
        </div>
        <div class="gb-tabs-body">
          <div class="t1">



            <div class="list" v-if="curr > -1">

              <div class="itm">


                <div class="box">
                  <div class="tab">
                    <table class="pic_bustypebox">
                      <tbody>
                        <tr>
                          <th> {{ $lang(51404) }} </th>
                          <td>{{ itm.tag.tit }}</td>
                        </tr>
                        <tr>
                          <th>{{ $lang(51405) }}</th>
                          <td>{{ itm.total_num }} 席</td>
                        </tr>
                        <tr>
                          <th>{{ $lang(51406) }}</th>
                          <td>{{ itm.angle }} {{ $lang(51407) }}</td>
                        </tr>
                        <tr>
                          <th>{{ $lang(51408) }}</th>
                          <td> {{ itm.width }} </td>
                        </tr>
                        <tr>
                          <th>{{ $lang(51409) }}</th>
                          <td> {{ itm.diff }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="rigimg">
                    <img :src="itm.strs.right_img" alt="">
                  </div>
                </div>

                <div class="desc">
                  {{ itm.strs.desc }}
                </div>

                <div class="banner">
                  <img v-for="(src, j) in itm.strs.banner" :key="j" :src="src" alt="" />
                </div>

                <div class="btn1">
                  <el-button class="" type="primary" @click="show_tc(curr)">{{ $lang(51414) }} </el-button>
                </div>
              </div>
            </div>


            <el-dialog :title="$lang(51415)" :visible.sync="show">
              <div class="p2">
                <div class="l1">
                  <div class="tit1">{{ this.$lang('37401') }}</div>
                  <div class="ttt2">
                    <!-- <img class="icon" src="~@/../static/image/icon8.png" alt="" /> -->
                    <el-cascader class="ipt" v-model="map.start_id" :placeholder="this.$lang('37403')"
                      :options="options" @change="start_change" filterable>
                    </el-cascader>

                  </div>
                </div>

                <div class="l1">
                  <div class="tit1">{{ this.$lang('37411') }}</div>
                  <div class="ttt2">
                    <!-- <img class="icon" src="~@/../static/image/icon8.png" alt="" /> -->
                    <el-cascader class="ipt" v-model="map.end_id" :placeholder="this.$lang('37404')" :options="options"
                    @change="end_change"   filterable>
                    </el-cascader>

                  </div>
                </div>



                <div class="l1">
                  <div class="tit1">{{ this.$lang('37402') }}</div>
                  <div class="ttt2">
                    <!-- <img class="icon_s" src="~@/../static/image/icon9.png" alt="" /> -->
                    <el-date-picker class="ipt" v-model="map.date" value-format="yyyy-MM-dd" align="right" type="date"
                      :placeholder="this.$lang('37405')" :picker-options="pickerOptions"> </el-date-picker>

                  </div>
                </div>

                <div class="l1">
                  <div class="tit1">{{ this.$lang('38459') }}</div>
                  <div class="ttt2 sel3">
                    <div class="labe2 labe1 " v-for="(itm, i) in tags.bus_type" :key="i" @click="set_type(itm.id)"
                      v-bind:class="{ labe_act: map.bus_type == itm.id }">
                      <div class="text11">{{ itm.title }}</div>
                    </div>

                  </div>
                </div>



                <el-button class="btnz" @click="to_search" icon="el-icon-search">{{ $lang(51416) }} </el-button>

              </div>


            </el-dialog>


          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>


import nav_list from '../index/nav_list.vue';
export default {
  name: "bus_list",

  components: {
    nav_list,
  },

  data() {
    return {
      show : false,
      list: [],
      pickerOptions: {
        disabledDate(time) {
          if (time.getTime() < new Date(new Date().toLocaleDateString()).getTime()) {
            return true
          }
          if (time.getTime() > (Date.now() + 1000 * 60 * 60 * 24 * 30)) {
            return true
          }
          return false
        },


      },
      options: [

      ],
      tags: {},
      map: {
        start_id: 0,
        end_id: 0,
        date: '',
        time_division_type: 0,
        bus_type : '',
      },

      bus_type_id : 0,
      curr: -1,
      itm : {},
    };
  },
  mounted(e) {
    document.title = this.web_tit;
    this.f5()
  },

  methods: {
    set_type(id){
     
      this.map.bus_type = id
    },
    show_tc(i){
      console.log('xda', i)
      
      this.map.bus_type = this.tags.bus_type[i].id
      console.log('xda', this.map.bus_type)
      this.show = true
     
      this.$forceUpdate()
    },
    to_search() {
      if (!this.map.start_id) {
        return this.$message(this.$lang('37403'));
      }
      if (!this.map.end_id) {
        return this.$message(this.$lang('37404'));
      }
      // console.log(this.map.end_id)
      // return
      this.cache('home_map', this.map)

      this.cache('list_map', '')
      console.log(this.cache('list_map'))
      this.show = false
      this.jump('/search')
    },
    show_point(id) {
      // alert(id)

      this.$refs.pot_tc.f5(id)
    },
    start_change(e){
      this.options.map((item) => {
        if (item.value == e[0]) {
           this.map.start_city_key = item.key
        }
      })
       
    },
    end_change(e){
      console.log(e)
      this.options.map((item) => {
        if (item.value == e[0]) {
           this.map.end_city_key = item.key
        }
      })
    },
    f5() {
      this.get("/index/seat_v4", {},).then((e) => {
        this.map = e.map
        this.options = e.city;
        this.list = e.list
        this.tags = e.tags
        this.set_curr(0)
      });
    },
    set_curr(i){
      this.curr = i 
      this.itm = this.list[i]
    }

  }
}
</script>
<style scoped>
.sel3 {

      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-items: center;
    }
.labe2 {

  height: 26px;
  line-height: 26px;
  border-radius: 8px;
  margin-right: 1%;
  margin-top: 2%;
  flex: 0 0 28%;
  padding: 0px 4px;
  white-space: nowrap;
  overflow: hidden;
  text-align: center;
  color: #50A2F8;
  border: 1px solid #50A2F8;
}
.labe1 {
  
}

.labe_act {
  background: #50A2F8;
    color: #fff;
}

.p2 {
  width: 70%;
  margin: auto;
  
  padding: 40px;
  text-align: center;
}
.l1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

}

.btnz {
  margin-top: 40px;
  background: #50A2F8;
  color: #fff;
  width: 200px;
}
.tit1 {
  padding: 10px 20px;
   

    font-size: 15px;
    font-weight: bold;
    line-height: 1.6;
}
.ttt2 {
  text-align: left;
  flex: 0 0 80%;
}
.t1 {
   
  margin: auto;
}
.t0tit {
  margin: 30px auto;
  text-align: center;
  height: 80px;
  line-height: 80px;
  font-size: 30px;
  font-weight: bold;
}


 
.tit {
      padding: 11px 15px 10px;
        background: #1a54a2;
        color: #fff;
        font-size: 15px;
        font-weight: bold;
        line-height: 1.6;
}

.box {
  padding:   20px ;
    border: solid 2px #dadada;
    background: #fff;
    overflow: hidden;
    display: flex;
    align-content: center;
    align-items: center;

}

.box .pic_bustypebox {

  width: 100%;
        font-size: 90%;
        border-collapse: collapse;
        border-spacing: 0;
        margin-bottom: 20px;
}
.box td,  th {


      border: 1px solid #eee;
      padding: 5px 0px;
}

.box .tab {
  flex: 0 0 40%;
}
.box .rigimg {
  flex: 0 0 60%;
}
.desc {
  padding: 18px ;
    line-height: 1.8;
      border: solid 2px #dadada;
}
.rigimg img {
  width: 100%;
}

.banner {
  border: solid 2px #dadada;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 18px;
}
.banner img {
  width: 25%;
  margin-left: 2%;
}

.btn1 {
  margin: 20px auto;
  text-align: center;
}
.gb-tabs {
  width: 60%;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/seat.vue